import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import "./dialog.css";

import React from "react";
import Inputs from "../inputs/Inputs";

const Detaildialog = ({
  open,
  onClose,
  width,
  text,
  title,
  content,
  height,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={width}>
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent style={{ height: height ?? "" }}>
        <DialogContentText>{content && content()}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Inputs
          color="primary"
          size="small"
          inputType="button"
          text="Close"
          type="submit"
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default Detaildialog;
